var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdReach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4931 3.14357C66.5724 2.31894 65.9682 1.58618 65.1436 1.50689L51.7055 0.214769C50.8809 0.135478 50.1482 0.73969 50.0689 1.56431C49.9896 2.38894 50.5938 3.12171 51.4184 3.201L63.3633 4.34954L62.2148 16.2945C62.1355 17.1191 62.7397 17.8518 63.5643 17.9311C64.3889 18.0104 65.1217 17.4062 65.201 16.5816L66.4931 3.14357ZM8.95427 51.1573L65.9543 4.15731L64.0457 1.84269L7.04573 48.8427L8.95427 51.1573Z",
    fill: "#F44C5C",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.491 51.0222L29.7421 82.1896L36.7178 77.1913L44.0394 81.8176L41.7564 51.0222L33.491 51.0222Z",
    fill: "#009846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7566 50.9556L41.8829 52.6477L33.2966 52.6477L33.4894 51.0233L41.7566 50.9556Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6429 50.9122C34.4083 57.404 33.9192 63.8829 33.1712 70.3298C33.4038 63.8379 33.8968 57.3593 34.6429 50.9122Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9304 50.353C41.418 57.0841 41.6534 63.8297 41.6298 70.5717C41.1402 63.8405 40.9087 57.0949 40.9304 50.353Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7309 50.6374C37.8996 57.3266 37.8145 64.0183 37.4702 70.6941C37.2995 64.0048 37.3884 57.3132 37.7309 50.6374V50.6374Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3679 50.4914C39.6568 57.2694 39.6925 64.0541 39.469 70.8276C39.1781 64.0498 39.1461 57.265 39.3679 50.4914Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1715 50.7759C36.1177 57.4702 35.8096 64.1589 35.2422 70.8231C35.2941 64.1287 35.606 57.4403 36.1715 50.7759V50.7759Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7268 16.6473C24.7268 16.6473 30.2081 4.33173 37.5343 4.33174C48.1446 4.33175 50.6211 17.9886 50.6211 17.9886C50.6211 17.9886 57.645 21.8592 57.44 34.3035C57.2694 44.6559 47.4531 51.6798 37.5343 51.5185C29.9169 51.3946 18.9696 47.3125 17.2896 37.0114C15.6095 26.71 24.7268 16.6473 24.7268 16.6473Z",
    fill: "#009846"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0636 45.9408C40.0923 45.2305 40.534 47.2173 40.8708 48.0483C41.2538 48.9934 41.5655 49.4351 42.2397 49.5322",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5062 45.9472C44.3033 45.2066 43.9007 47.2783 43.5937 48.1446C43.2443 49.1303 42.9603 49.5909 42.3456 49.6922",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2476 45.9374C45.7453 45.2431 45.4098 47.1853 45.1539 47.9974C44.8628 48.9215 44.626 49.3533 44.1138 49.4483",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9376 45.9408C27.9663 45.2305 28.408 47.2173 28.7448 48.0483C29.1279 48.9934 29.4396 49.4351 30.1138 49.5322",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4697 45.9883C29.4986 45.278 29.9402 47.2648 30.2769 48.0956C30.6601 49.0409 30.9717 49.4826 31.6459 49.5798",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1217 45.9374C33.6193 45.2431 33.2838 47.1853 33.0279 47.9974C32.7369 48.9215 32.5001 49.3533 31.9879 49.4483",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8088 17.9885C50.8088 17.9885 50.9395 19.065 50.8088 26.7679C50.6999 33.1823 42.2872 35.7475 35.9642 35.6477C29.5633 35.5467 24.0479 31.2206 24.1582 24.7211C24.2305 20.4634 23.4139 19.3517 24.5355 16.891C25.925 13.8426 26.4302 13.5988 26.4302 13.5988C27.1881 11.8917 28.5358 10.1791 30.346 8.23355C31.7801 6.69216 33.3143 4.92174 36.0301 4.45357C43.1036 3.23416 47.272 9.94071 47.272 9.94071C47.272 9.94071 47.9036 10.4284 48.4088 11.8917C49.5456 13.9646 49.1992 13.2952 49.7983 14.8182C50.3978 16.3424 50.8088 17.9885 50.8088 17.9885Z",
    fill: "white",
    fillOpacity: 0.301961
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5451 14.6963C50.0504 16.4034 51.5662 18.9641 47.3978 20.6712C43.7347 21.7686 45.9733 19.4518 38.6471 19.4518C30.8156 19.086 33.3102 21.1589 28.6683 19.9396C26.2865 19.3139 26.5561 13.2331 26.5561 13.2331L28.0718 10.8244C28.0718 10.8244 30.2949 8.51886 33.3102 8.47754L43.2627 8.63464C47.3707 8.6995 49.0399 12.9892 49.5451 14.6963Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2886 16.9998L37.863 14.8183L34.5137 16.9998L37.863 21.5248L41.2886 16.9998Z",
    fill: "#263138"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5771 13.7529C41.4156 12.5324 43.5956 10.8237 45.6079 13.7529",
    stroke: "black",
    strokeWidth: 1.70825
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7246 13.7529C31.5631 12.5324 33.7431 10.8237 35.7554 13.7529",
    stroke: "black",
    strokeWidth: 1.70825
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9094 32.2375L0.449693 5.21953C0.449693 5.21953 12.3775 8.6049 17.6765 15.2764C24.4143 23.7594 21.9094 32.2375 21.9094 32.2375V32.2375Z",
    fill: "#009846"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9094 32.2375L0.449693 5.21953C0.449693 5.21953 12.3775 8.6049 17.6765 15.2764C24.4143 23.7594 21.9094 32.2375 21.9094 32.2375V32.2375Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13391 8.74864C9.39971 8.88707 9.66871 9.02926 9.93691 9.17862C13.3928 13.4988 16.8116 17.9032 19.9751 22.1173C16.4137 17.8688 12.7164 13.3102 9.13391 8.74864Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76487 7.17099C5.9742 7.26271 6.18356 7.3544 6.4001 7.44705C10.5904 12.6269 14.7981 18.0087 18.6294 23.1128C14.3914 18.0694 9.96568 12.5769 5.76487 7.17099Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74119 5.99519C2.88258 6.04237 3.03034 6.09738 3.18124 6.1565C7.98866 12.0236 12.8809 18.2513 17.2795 24.1111C12.4824 18.3881 7.42886 12.0963 2.74119 5.99519V5.99519Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8538 33.0123L74.7535 7.18108C74.7535 7.18108 62.631 9.89887 56.9764 16.2774C49.7864 24.3877 51.8538 33.0123 51.8538 33.0123V33.0123Z",
    fill: "#009846"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8538 33.0123L74.7535 7.18108C74.7535 7.18108 62.631 9.89887 56.9764 16.2774C49.7864 24.3877 51.8538 33.0123 51.8538 33.0123V33.0123Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8882 10.2234C65.6148 10.3475 65.3379 10.4751 65.0614 10.61C61.3694 14.7433 57.7097 18.963 54.316 23.006C58.1098 18.95 62.0564 14.5913 65.8882 10.2234Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3404 8.8238C69.1259 8.9042 68.9114 8.98456 68.6897 9.06549C64.2161 14.0188 59.7141 19.1732 55.6038 24.0702C60.1178 19.2559 64.8439 14.0026 69.3404 8.8238Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4253 7.80755C72.2812 7.84708 72.1304 7.8941 71.9762 7.94505C66.8477 13.5523 61.6148 19.5156 56.8958 25.1377C62.0062 19.674 67.4039 13.6553 72.4253 7.80755V7.80755Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_332_1970)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.3767,
    cy: 15.7937,
    rx: 4.29468,
    ry: 1.21937,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_332_1970)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4724,
    cy: 15.5497,
    rx: 4.29468,
    ry: 1.21937,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_332_1970",
    x: 39.3738,
    y: 12.8661,
    width: 12.0063,
    height: 5.85523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.854125,
    result: "effect1_foregroundBlur_332_1970"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_332_1970",
    x: 24.4695,
    y: 12.6221,
    width: 12.0063,
    height: 5.85523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.854125,
    result: "effect1_foregroundBlur_332_1970"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdReach);
export default __webpack_public_path__ + "static/media/bird_reach.19dbb1ed8b5ce223cf41f9dbeebe7c14.svg";
export { ForwardRef as ReactComponent };